export default "__VITE_ASSET__20b3736c__"